export default __webpack_public_path__ + "static/media/Rating.c1241335.mp3";